import Swal from 'sweetalert2';

export const fireNotification = (config) => {
    const defaultConfig = {
        icon: config.icon ?? 'success',
        iconColor: config.iconColor ?? undefined,
        title: config.title ?? 'Operacja wykonana pomyślnie',
        text: config.text ?? '',
        html: config.html ?? '',
    }
    // Swal.fire(defaultConfig);
    const Toast = Swal.mixin({
        toast: true,
        position: config.position ?? 'top-start',
        showConfirmButton: false,
        timer: config.timer ?? 1500,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    Toast.fire(defaultConfig)
}